<script>
import Picker from '../picker';
import TimePanel from '../panel/time';
import TimeRangePanel from '../panel/time-range';

export default {
  name: 'ElTimePicker',
  mixins: [Picker],

  props: {
    isRange: Boolean,
    arrowControl: Boolean,
    now: Boolean,
    // 分钟 / 秒跨度
    stepper: [Number, Boolean],
    // 点击 <此刻> 不关闭 picker
    clickNowShowPicker: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      type: ''
    };
  },

  watch: {
    isRange (isRange) {
      if (this.picker) {
        this.unmountPicker();
        this.type = isRange ? 'timerange' : 'time';
        this.panel = isRange ? TimeRangePanel : TimePanel;
        this.mountPicker();
      } else {
        this.type = isRange ? 'timerange' : 'time';
        this.panel = isRange ? TimeRangePanel : TimePanel;
      }
    }
  },

  created () {
    this.type = this.isRange ? 'timerange' : 'time';
    this.panel = this.isRange ? TimeRangePanel : TimePanel;
  }
};
</script>



// WEBPACK FOOTER //
// elTimePicker.vue?03cbc769